import { useEffect, useMemo, useRef } from "react";
import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { AppMarkdownParser } from "../../../../../shared/components/AppMarkdownParser";
import { selectChatHistory } from "../../../redux/selectors";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useTranslation } from "react-i18next";

export const ChatLogs = () => {
  const history = useAppSelector(selectChatHistory);
  const { selectedId } = useStorageSelectors("assistants");
  const containerRef = useRef<HTMLDivElement>(null);
  const lastItemRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const currentHistory = useMemo(() => {
    if (selectedId) {
      return history[selectedId] ? history[selectedId] : [];
    }
  }, [history, selectedId]);

  useEffect(() => {
    if (lastItemRef.current && containerRef.current) {
      lastItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [currentHistory]);

  if (!currentHistory || currentHistory.length === 0) {
    return (
      <div className={styles["logs-container"]}>{t("agents.no_data")}</div>
    );
  }

  return (
    <div ref={containerRef} className={styles["logs-container"]}>
      {currentHistory.map((item, index) => {
        const isLast = index === currentHistory.length - 1;
        const content = `\`\`\`json\n${JSON.stringify(item, null, 2)}\n\`\`\``;

        return (
          <div
            key={index}
            ref={isLast ? lastItemRef : null}
            className={styles["log-entry"]}
          >
            <div className={styles["step-label"]}>
              {`${t("agents.steps")} ${index + 1}`}{" "}
            </div>
            <AppMarkdownParser content={content} />
            {index < currentHistory.length - 1 && (
              <div className={styles["separator"]} />
            )}
          </div>
        );
      })}
    </div>
  );
};
